
import AvailabilityConsolidatedSimplified from './AvailabilityConsolidatedSimplified';
import AvailabilityConsolidatedPerStepSimplified from './AvailabilityConsolidatedPerStepSimplified';
import {getMonitorsList} from '../../../../services/getMonitorsList'

import React, { Component } from 'react';

// Externals
import classNames from 'classnames';
import compose from 'recompose/compose';

import Period from '../../../../helpers/Period';

// Material helpers
import { withStyles } from '@material-ui/core/styles';
import Grid from '@material-ui/core/Grid';
import { withRouter } from 'react-router-dom';

// Shared components
import Portlet from 'components/Portlet';
import PortletHeader from 'components/PortletHeader';
import PortletLabel from 'components/PortletLabel';
import PortletToolbar from 'components/PortletToolbar';
import PortletContent from 'components/PortletContent';
import PortletFooter from 'components/PortletFooter';
// Custom components
import List from '@material-ui/core/List';
import ListItem from '@material-ui/core/ListItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';

// Material components
import IconButton from '@material-ui/core/IconButton';
import Typography from '@material-ui/core/Typography';
import Popover from '@material-ui/core/Popover';

import RefreshIcon from '@material-ui/icons/Refresh';

import SettingsOutlinedIcon from '@material-ui/icons/SettingsOutlined';
import InfoIcon from '@material-ui/icons/Info';
import Switch from '@material-ui/core/Switch';
import QueryBuilderIcon from '@material-ui/icons/QueryBuilder';
import UpdateIcon from '@material-ui/icons/Update';
import Avatar from '@material-ui/core/Avatar';
import HelpIcon from '@material-ui/icons/Help';

import Button from '@material-ui/core/Button';
import ArrowDropDownIcon from '@material-ui/icons/ArrowDropDown';
import ArrowRightIcon from '@material-ui/icons/ArrowRight';
import Tooltip from '@material-ui/core/Tooltip';

import PerfectScrollbar from 'react-perfect-scrollbar';
import Highcharts from 'highcharts/highstock'
// Palette
import palette from 'theme/palette';

// Component styles
import styles from './styles';

import moment from 'moment-timezone'
import 'moment/locale/es'
moment.locale('es')


class AvailabilitySimplified extends Component {
    constructor(props) {
        super(props);
        
        this.handleAvailabilityConsolidatedClick = this.handleAvailabilityConsolidatedClick.bind(this);
        this.handleAvailabilityConsolidatedPerStepClick = this.handleAvailabilityConsolidatedPerStepClick.bind(this);
        this.handleNextNodeClick = this.handleNextNodeClick.bind(this);
        this.handleInfo = this.handleInfo.bind(this);
        this.handleFirstInfo = this.handleFirstInfo.bind(this);
        this.handleDateMoment = this.handleDateMoment.bind(this);
        this.state = {
            typeGraph: this.props.typeGraph,
            period: this.props.params.period,
            step: 'step',
            steps: this.props.isSecondObjective ? this.props.params.objectiveSecond.Pasos : this.props.params.objectiveFirst.Pasos,
            node: 0,
            isForNode: false,
            namePeriod: null,
            x2: null,
            x: null,
            y: null,
            isLastEvent: false,
            objetive: this.props.isSecondObjective ? this.props.params.objectiveSecond.objetivo_id : this.props.params.objectiveFirst.objetivo_id,
            statePeriod: this.props.params.statePeriod,
            isStatePeriod: false,
            responseTimeGraphEl: null,
            periodEl: null,
            extendEl: null,
            nameGraph: [' Consolidada', ' Consolidada Por Paso'],
            typePeriod: this.props.params.typePeriod,
            nameNodo:"Seleccione ISP",
            settingsEl: null,
            isRefresh: false,
            isInfo: null,
            checkedA: false,
            date: new Date(),
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("DD/MM/YYYY, h:mm:ss a")),
            isOneHour: true,
            detalleGraph:['  Corresponde a la disponibilidad del objetivo durante el período y horario seleccionado','  Corresponde a la disponibilidad del objetivo por paos, durante el período y horario seleccionado'],
            extendView: this.props.extendView,
            nodes: this.props.isSecondObjective ? this.props.params.objectiveSecond.Nodos : this.props.params.objectiveFirst.Nodos,
            intervalId: null,
        };
    }

    componentWillUnmount() {
        clearInterval(this.state.intervalId);
    }
    
    tick() {
        this.setState({
            date: new Date(),
            dateMoment:(moment().tz(sessionStorage.getItem('tz')).format("dddd, DD/MM/YYYY, h:mm:ss a"))
        });
    }

  
    handleAvailabilityConsolidatedClick() {
        if(this.props.isSecondObjective){
            this.props.handleTypegraph('typegraphSecond', 0)
        }else {
            this.props.handleTypegraph('typegraphFirst', 0)
        }
        this.setState({
            typeGraph: 0,
            isForStep: false,
            isForNode: false,
            isLastEvent: false,
            nameNodo:"Seleccione ISP",
            responseTimeGraphEl: null,
            isRefresh: false,
            node: 0,
            nameStep: null,
            x2: null,
            x: null,
            y: null,
        });
    }
    handleAvailabilityConsolidatedPerStepClick() {
        if(this.props.isSecondObjective){
            this.props.handleTypegraph('typegraphSecond', 1)
        }else {
            this.props.handleTypegraph('typegraphFirst', 1)
        }
        let node = 0
        let nameNodo = null
        let isFull = false
        const {nodes} = this.state
        console.log(nodes)
        Object.values(nodes).map(i => { 
            if (i.id_nodo != 0 && !isFull){
                node = i.id_nodo
                isFull = true
                nameNodo = i.nodo
            }
        })

        this.setState({
            typeGraph: 1,
            isForStep: false,
            isForNode: true,
            isLastEvent: false,
            nameNodo: nameNodo,
            responseTimeGraphEl: null,
            isRefresh: false,
            node: node,
            nameStep: null,
            x2: null,
            x: null,
            y: null,
        });
    }

    
    handleNextNodeClick = event => {
        const nameNodo = event.currentTarget.name
        const newNode = event.currentTarget.id
        if (this.state.node !== newNode) {
            this.setState({
                //typeGraph: prevTypeGraph,
                //period: prevPeriod,
                node: newNode,
                isLastEvent: false,
                extendEl: null,
                isRefresh: false,
                nameNodo: nameNodo,
            })
        }
    }

    handleRefresh = event => {
        this.setState({
            isRefresh: true,
            settingsEl: null,
        })
    }

    handleInfo(props, step) {
        let oldDate = new Date(props.x)
        if (isNaN(oldDate)) {
            this.setState({
                nameStep: step,
                x: props.x,
                y: props.y
            })
        } else {
            
            let year = oldDate.getUTCFullYear()
            let month = oldDate.getUTCMonth()
            let day = oldDate.getUTCDate()
            let hours = oldDate.getUTCHours()
            let minutes = oldDate.getUTCMinutes()
            let seconds = oldDate.getUTCSeconds()

            let oldDateX2 = new Date(props.x2)
            let yearX2 = oldDateX2.getUTCFullYear()
            let monthX2 = oldDateX2.getUTCMonth()
            let dayX2 = oldDateX2.getUTCDate()
            let hoursX2 = oldDateX2.getUTCHours()
            let minutesX2 = oldDateX2.getUTCMinutes()
            let secondsX2 = oldDateX2.getUTCSeconds()

            let newDate = new Date(year, (month), day, hours, minutes, seconds)
            let newDateX2 = new Date(yearX2, (monthX2), dayX2, hoursX2, minutesX2, secondsX2)
            this.setState({
                nameStep: step,
                x: newDate.toLocaleString(),
                x2: newDateX2.toLocaleString(),
                y: props.y
            })
        }
    }
    handleDateMoment(props) {
        this.setState({
            dateMoment:props,
            isRefresh: false
        })
    }

    handleFirstInfo(props) {
        let oldDate = new Date(props.x)
        if (isNaN(oldDate)) {
            if (!this.state.isLastEvent && props.name !== null) {
                this.setState({
                    nameStep: props.name,
                    namePeriod: props.namePeriod,
                    x: props.x,
                    y: props.y,
                    isLastEvent: true
                })
            }
        } else {
            let year = oldDate.getUTCFullYear()
            let month = oldDate.getUTCMonth()
            let day = oldDate.getUTCDate()
            let hours = oldDate.getUTCHours()
            let minutes = oldDate.getUTCMinutes()
            let seconds = oldDate.getUTCSeconds()
            let newDate = new Date(year, (month), day, hours, minutes, seconds)
            if (!this.state.isLastEvent && props.name !== null) {
                this.setState({
                    nameStep: props.name,
                    x: newDate.toLocaleString(),
                    y: props.y,
                    namePeriod: props.namePeriod,
                    isLastEvent: true
                })
            }
        }
    }
    handleShowSettings = event => {
        this.setState({
            settingsEl: event.currentTarget
        });
    };
    handleShowIsInfo = event => {
        this.setState({
            isInfo: event.currentTarget
        });
    };
    handleCloseSettings = () => {
        this.setState({
            settingsEl: null
        });
    };

    handleCloseIsInfo = () => {
        this.setState({
            isInfo: null
        });
    };


    handleShowPeriod = event => {
        this.setState({
            periodEl: event.currentTarget
        });
    };

    handleClosePeriod = () => {
        this.setState({
            periodEl: null
        });
    };

    handleShowExtend = event => {
        this.setState({
            extendEl: event.currentTarget
        });
    };
    handleCloseExtend = () => {
        this.setState({
            extendEl: null
        });
    };
    handleChange = name=>event => {
        this.setState({ 
            checkedA: event.target.checked 
        });
        if (event.target.checked) {
            const newInterval = setInterval(
                () => this.tick(),
                300000
              );
            this.setState({intervalId: newInterval});
        } else {
            clearInterval(this.state.intervalId)
        }
    };

    componentDidUpdate(prevProps, prevState) { 
        if (this.props.isSecondObjective === true){
            if (prevProps.params.objectiveSecond.objetivo_id !== this.props.params.objectiveSecond.objetivo_id 
                || prevProps.extendView !== this.props.extendView
                || prevProps.params.period !== this.props.params.period
                || prevProps.params.date !== this.props.params.date) {
                this.onLayoutChange()
                this.setState({
                    typeGraph: this.props.typeGraph,
                    period: this.props.params.period,
                    step: this.state.step,
                    isForStep: false,
                    nameStep: null,
                    x: null,
                    y: null,
                    isLastEvent: false,
                    objetive: this.props.params.objectiveSecond.objetivo_id,
                    periodEl: null,
                    statePeriod: this.props.params.statePeriod, 
                    date: this.props.params.date
                })
            }

        }else {
            if (prevProps.params.objectiveFirst.objetivo_id !== this.props.params.objectiveFirst.objetivo_id 
                || prevProps.extendView !== this.props.extendView
                || prevProps.params.period !== this.props.params.period
                || prevProps.params.date !== this.props.params.date) {
                this.onLayoutChange()
                this.setState({
                    typeGraph: this.props.typeGraph,
                    period: this.props.params.period,
                    step: this.state.step,
                    isForStep: false,
                    nameStep: null,
                    x: null,
                    y: null,
                    isLastEvent: false,
                    objetive: this.props.params.objectiveFirst.objetivo_id,
                    periodEl: null,
                    statePeriod: this.props.params.statePeriod, 
                    date: this.props.params.date
                })
            }

        }
        
    }

    onLayoutChange = (e) => {  
        for (let i = 0; i < Highcharts.charts.length; i += 1) {
            if (Highcharts.charts[i] !== undefined) {
              Highcharts.charts[i].reflow(); // here is the magic to update charts' looking
            }
        }
    }
    componentDidMount() {
        this.getDataFromAPI();
    }
    getDataFromAPI=()=>{
        const {period, objetive, statePeriod, nodes, typeGraph, node, nameNodo} = this.state;
        let token = sessionStorage.getItem('key')
        //var begin = statePeriod.startDate.toISOString().substring(0, 10)
        //var final = statePeriod.endDate.toISOString().substring(0, 10)   
        if (period == 'c'){
            var begin = statePeriod.startDate.toISOString().substring(0, 10)
            var final = statePeriod.endDate.toISOString().substring(0, 10)   
        }else{
            var begin = statePeriod.startDate
            var final = statePeriod.endDate 
        }
        
        var getData = getMonitorsList(objetive, begin, final, token)           
        getData.then( data =>  { 
            var nodeBeta = node
            var nameNodoBeta = nameNodo
            var isFull = false
            if (typeGraph === 8){
                Object.values(data).map(i => { 
                    if (i.id_nodo != 0 && !isFull){
                        nodeBeta = i.id_nodo
                        isFull = true
                        nameNodoBeta = i.nodo
                    }
                })
            }
            this.setState({
                nodes:data,
                node:nodeBeta,
                nameNodo:nameNodoBeta
            })
        })     
            
    }

    handleShowResponseTimeGraph = event => {
        this.getDataFromAPI();
        this.setState({
            responseTimeGraphEl: event.currentTarget
        });
    };
    
    handleCloseResponseTimeGraph = () => {
        this.setState({
            responseTimeGraphEl: null
        });
    };

    render() {
        const { classes, className, params, isSecondObjective } = this.props;
        const { typeGraph, period, step, x2, x, y, nameStep, statePeriod, isStatePeriod, 
            namePeriod, node, isForNode, responseTimeGraphEl, periodEl, nameGraph, namePeriodPorlet,
            typePeriod, extendEl, settingsEl, isRefresh, isInfo, detalleGraph, date, dateMoment, nameNodo, nodes} = this.state;
        let buttonAvailabilityConsolidated;
        let buttonAvailabilityConsolidatedPerStep;
        const showExtendEl = Boolean(extendEl);

        buttonAvailabilityConsolidated = <AvailabilityConsolidatedButton onClick={this.handleAvailabilityConsolidatedClick}/>;
        buttonAvailabilityConsolidatedPerStep = <AvailabilityConsolidatedPerStepButton onClick={this.handleAvailabilityConsolidatedPerStepClick}/>;
        const showResponseTimeGraphEl = Boolean(responseTimeGraphEl);
        const showSettingsEl = Boolean(settingsEl);
        const showIsInfo = Boolean(isInfo);
        const showPeriodEl = Boolean(periodEl);
        const rootClassName = classNames(classes.root, className);

        return (

            <Portlet
                    /*  {...rest} */
                    className={rootClassName}
                >
                    <PortletHeader className={classes.header}
                    >
                        <PortletLabel
                            /*  icon={<DevicesIcon />} */
                            variant="h6"
                            title={this.props.title + nameGraph[typeGraph]}
                        />

                        <PortletToolbar>
                            <IconButton
                                //className={classes.refreshButton}
                                //variant="text"
                                onClick={this.handleShowSettings}
                            >
                                <SettingsOutlinedIcon />
                                
                            </IconButton>
                            <Popover
                                    anchorEl={settingsEl}
                                    onClose={this.handleCloseSettings}
                                    open={showSettingsEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'left',
                                      }}
                                      transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'left',
                                      }}
                                    >
                                    <IconButton
                                        className={classes.refreshButton}
                                        variant="text"
                                        onClick={this.handleRefresh}
                                        onClose={this.handleCloseSettings}
                                    >
                                        <div>
                                            <RefreshIcon color="infoIcon" /><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Actualizar</Typography>
                                        </div>
                                    </IconButton>
                                    <IconButton
                                        onClick={this.handleShowIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                    >
                                        <div>
                                            <HelpIcon color="infoIcon"/><Typography variant="h4" style={{fontSize:'15px',float:'right', paddingLeft:'5px', color:'#66788A'}}>Información</Typography>
                                        </div>
                                    </IconButton>
                                     <Popover
                                        anchorEl={isInfo}
                                        open={showIsInfo}
                                        onClose={this.handleCloseIsInfo}
                                        >
                                        <PortletContent variant="h4" style={{fontSize:'16px', color:'#66788A'}}>{detalleGraph[typeGraph]}</PortletContent>
                                    </Popover>
                                    <Tooltip title="Actualización Automatica cada 5 minutos">
                                        <div style={{textAlign:"center"}}>
                                            <Switch
                                                checked={this.state.checkedA}
                                                onChange={this.handleChange('checkedA')}
                                                value="checkedA"
                                                inputProps={{ 'aria-label': 'secondary checkbox' }}
                                                color='primary'
                                            />
                                        </div>
                                    </Tooltip>
                                </Popover>   
                                <Button
                                    style={{color:"#353535"}}
                                    variant="text"
                                    onClick={this.handleShowResponseTimeGraph}
                                    >
                                        Gráficos <ArrowDropDownIcon />
                                </Button>    
                            {/* Popover para mostrar la seleccion de graficos, segun distribucion*/}
                            <Popover
                                anchorEl={responseTimeGraphEl}
                                anchorOrigin={{
                                    vertical: 'bottom',
                                    horizontal: 'center'
                                }}
                                onClose={this.handleCloseResponseTimeGraph}
                                open={showResponseTimeGraphEl}
                                transformOrigin={{
                                    vertical: 'top',
                                    horizontal: 'center'
                                }}>
                                <div>
                                    {buttonAvailabilityConsolidated}
                                    {buttonAvailabilityConsolidatedPerStep}
                                </div>                              
                               
                            </Popover>
                        </PortletToolbar>
                    </PortletHeader>
                    <PortletContent className={classes.content}>
                        <Grid
                            container
                            spacing={10}
                        >
                            <Grid
                                item
                                xs={12}
                                sm={12}
                                md={12}
                                xl={12}>
                                <PerfectScrollbar>
                                   
                                <div >
                                {period == 'c' ?
                                            <div >
                                                <Typography   color="textSecondary" gutterBottom>
                                                    desde {statePeriod.startDate.toISOString().substring(0, 10)} hasta {statePeriod.endDate.toISOString().substring(0, 10)}
                                                </Typography>
                                            </div>
                                            
                                        : null}
                                    {<Graph
                                        typeGraph={typeGraph}
                                        period={period}
                                        step={step}
                                        node={node}
                                        onInfo={this.handleInfo}
                                        onFirstInfo={this.handleFirstInfo}
                                        statePeriod={statePeriod}
                                        isStatePeriod={isStatePeriod}
                                        isRefresh={isRefresh} 
                                        date={date}
                                        onDateMoment={this.handleDateMoment}
                                        schedule={this.state.schedule}
                                        name={nameGraph[typeGraph]}
                                        nameStep={nameStep}
                                        objective={isSecondObjective ? params.objectiveSecond : params.objectiveFirst}/>
                                        }
                                        
                                </div>
                                <div>
                                    <div>
                                        <Typography  style={{fontSize:'13px',float:'left', paddingLeft:'5px', color:'#66788A'}}>
                                            {/*<h5>{namePeriod}</h5>*/}
                                            <h3>{y}</h3>
                                            <h1>{nameStep}</h1>
                                            <h5>{x} -</h5>
                                            <h5>{x2}</h5>
                                        </Typography>
                                    </div>
                                </div>                            
                                </PerfectScrollbar>
                            </Grid>
                        </Grid>
                        
                    </PortletContent>
                    
                    <PortletFooter className={classes.portletFooter}>
                        { isForNode ?
                            <div>
                                <Button
                                    color="primary"
                                    variant="text"
                                    onClick={this.handleShowExtend}
                                >
                                    {nameNodo} <ArrowRightIcon />
                                </Button>
                                
                                <Popover
                                    anchorEl={extendEl}
                                    anchorOrigin={{
                                        vertical: 'bottom',
                                        horizontal: 'center'
                                    }}
                                    onClose={this.handleCloseExtend}
                                    open={showExtendEl}
                                    transformOrigin={{
                                        vertical: 'top',
                                        horizontal: 'center'
                                    }}>
                                    <div >
                                        {isForNode ? <div className="row1">
                                                        <List component="div">
                                                            {Object.values(nodes).map(i => (
                                                                
                                                                <ListItem
                                                                    className={classes.listItem}
                                                                    component="div"
                                                                >
                                                                {typeGraph == 8 && i.nodo == 'Global' ?
                                                                    null
                                                                :
                                                                    <Button id={i.id_nodo} name={i.nodo} onClick={(event) => this.handleNextNodeClick(event)}>{i.nodo}</Button> 
                                                                }
                                                                </ListItem>))}
                                                        </List>
                                                    </div> 
                                            : 
                                                    <div> No hay información que mostrar</div>
                                        }
                                    </div>
                                </Popover> 
                            </div> 
                        :  null}
                        
                    </PortletFooter>
                </Portlet>
        )
    }
}

function Graph(props) {
    const typeGraph = props.typeGraph;
    if (typeGraph === 0) {
        return <AvailabilityConsolidatedSimplified params={props} />;
    }
    if (typeGraph === 1) {
        return <AvailabilityConsolidatedPerStepSimplified params={props} />;
    }
}

function AvailabilityConsolidatedButton(props) {
    return (
        <Button onClick={props.onClick}>
            Consolidada
      </Button>
    );
}

function AvailabilityConsolidatedPerStepButton(props) {
    return (
        <Button onClick={props.onClick}>
            Consolidada Por Paso
      </Button>
    );
}

export default
    compose(withRouter, withStyles(styles))(AvailabilitySimplified);